<script>
  // core components
  import { Route, Router } from "svelte-routing";
  import SettingsForm from "../../components/Forms/Setting/SettingsForm.svelte";
  export let location;
</script>

<Router url="settings">
    <Route component="{SettingsForm}" />
</Router>
